/** Fallback display name when user name is not available */
export const FALLBACK_USER_NAME = 'Unknown User';
